export const ENV = {
    mode: 'Production'
    , production: false
    , msalConfig: {
        auth: {
            clientId: 'ab4918a5-aa36-478b-88c7-598738ab85a5'
            , authority: 'https://login.microsoftonline.com/fe9c4641-3b53-43d0-af72-8f3e64d3aa05'
            , tenantId: 'fe9c4641-3b53-43d0-af72-8f3e64d3aa05'
        }
    }
    , apiConfig: {
        scopes: ['api://ab4918a5-aa36-478b-88c7-598738ab85a5/eos.api.access']
        , uri: '/api/*'
        , postLogoutRedirectUri: 'https://easyorder.dksh.com'
        , redirectUri: 'https://easyorder.dksh.com'
    }
    , unauthorizedConfig: {
        unauthorizedUrl: 'https://easyorder.dksh.com/#/unauthorized'
        , unauthorizedRedirect: 'https://easyorder.dksh.com'
    }
    , redirectConfig: {
        connectPlusUrl: 'https://clm.euris.com/dksh-hc/'
        , connectClientUrl: 'https://flpnwc-xlgtvarz5i.dispatcher.ap1.hana.ondemand.com'
    }
  }


// WEBPACK FOOTER //
// ./src/environment/environment.ts